<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>
    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span
            ><em name="Exhibition"></em><span>/</span
            ><span
              @click.prevent="toCampaignList"
              style="color: #1a73e8"
              class="pointer px-0"
              >官方行銷活動</span
            ><span>/</span
            ><span
              @click.prevent="toCampaignDetail"
              style="color: #1a73e8"
              class="pointer px-0"
              >{{ EventDetail.EventName }}</span
            ><span>/</span>編輯贈品贊助活動
          </div>
          <div>
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <article>
        <div class="contentBox">
          <div class="container">
            <h1>編輯贈品贊助活動</h1>
            <p class="my-3">&nbsp;</p>
            <p style="font-size: 20px; color: #1b6c9c">
              {{ EventDetail.EventName }}
            </p>
            <p class="my-3">&nbsp;</p>

            <p class="alert">
              <i class="fas fa-exclamation-circle"></i>
              請勿上傳與本展無關或是妨害社會善良風俗之內容，主辦單位有權刪除不適當的內容。
            </p>
            <p class="my-3">&nbsp;</p>

            <form id="form" @submit.prevent="AddCampaignPro">
              <input type="hidden" name="RegNo" />

              <div class="container-fluid px-0 mt-4">
                <div class="row mb-4">
                  <div
                    class="col-md-6 mb-2"
                    v-if="getRule('ProductImage').Field"
                  >
                    <p class="formTitle">
                      {{ getRule("ProductImage").FieldName }}
                      <span
                        v-if="getRule('ProductImage').IsFieldRequired"
                        class="red"
                        >*</span
                      >
                    </p>
                    <div class="card mb-3">
                      <div class="card-body py-2 px-4">
                        <div
                          class="row d-none d-md-flex py-1 border-bottom mb-2 text-secondary bold"
                          style="font-size: 0.85rem"
                        >
                          <div class="col-md-4">預覽圖</div>
                          <div class="col-md-4">規格要求</div>
                          <div class="col-md-4 text-center">操作</div>
                        </div>
                        <div class="row align-items-center pb-2">
                          <div
                            class="col-md-4 col-12 my-2 my-md-0 text-md-left text-center"
                          >
                            <div
                              class="border rounded bg-light d-flex align-items-center justify-content-center mx-auto mx-md-0"
                              style="
                                width: 70px;
                                height: 70px;
                                overflow: hidden;
                                max-width: 50%;
                              "
                            >
                              <img
                                v-if="hasImgfile"
                                :src="modelSrc"
                                class="img-fluid"
                                style="
                                  object-fit: cover;
                                  width: 100%;
                                  height: 100%;
                                "
                              />
                              <img
                                v-else
                                src="../../../assets/images/default.jpg"
                                class="img-fluid"
                                style="
                                  object-fit: cover;
                                  width: 100%;
                                  height: 100%;
                                "
                              />
                            </div>
                          </div>
                          <div
                            class="col-md-4 col-12 my-2 my-md-0 text-md-left text-center"
                          >
                            <div
                              class="text-secondary"
                              style="font-size: 0.8rem"
                            >
                              <div>
                                <i class="fas fa-info-circle mr-2"></i>最大 3MB
                              </div>
                              <div>
                                <i class="fas fa-file-image mr-2"></i>JPG, WEBP
                              </div>
                              <div>
                                <i class="fas fa-expand mr-2"></i>建議 500x500px
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="d-flex justify-content-center">
                              <label
                                class="btn btn-sm btn-outline-primary mb-0 mr-2 cursor-pointer px-3"
                              >
                                <i class="fas fa-upload"></i> 選擇圖片
                                <input
                                  type="file"
                                  accept=".jpg,.jpeg,.webp"
                                  class="d-none"
                                  @change="uploadImgPC($event, 'product')"
                                />
                              </label>
                              <button
                                v-if="modelSrc !== noImageSrc"
                                class="btn btn-sm btn-link text-secondary p-0"
                                title="重設"
                                @click.prevent="resetImg"
                              >
                                <i class="fas fa-trash-alt"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 mb-2" v-if="getRule('LOGO').Field">
                    <p class="formTitle">
                      {{ getRule("LOGO").FieldName }}
                      <span v-if="getRule('LOGO').IsFieldRequired" class="red"
                        >*</span
                      >
                    </p>
                    <div class="card mb-3">
                      <div class="card-body py-2 px-4">
                        <div
                          class="row d-none d-md-flex py-1 border-bottom mb-2 text-secondary bold"
                          style="font-size: 0.85rem"
                        >
                          <div class="col-md-4">預覽圖</div>
                          <div class="col-md-4">規格要求</div>
                          <div class="col-md-4 text-center">操作</div>
                        </div>
                        <div class="row align-items-center pb-2">
                          <div
                            class="col-md-4 col-12 my-2 my-md-0 text-md-left text-center"
                          >
                            <div
                              class="border rounded bg-light d-flex align-items-center justify-content-center mx-auto mx-md-0"
                              style="
                                width: 70px;
                                height: 70px;
                                overflow: hidden;
                                max-width: 50%;
                              "
                            >
                              <img
                                v-if="hasLogofile"
                                :src="logoSrc"
                                class="img-fluid"
                                style="
                                  object-fit: cover;
                                  width: 100%;
                                  height: 100%;
                                "
                              />
                              <img
                                v-else
                                src="../../../assets/images/default.jpg"
                                class="img-fluid"
                                style="
                                  object-fit: cover;
                                  width: 100%;
                                  height: 100%;
                                "
                              />
                            </div>
                          </div>
                          <div
                            class="col-md-4 col-12 my-2 my-md-0 text-md-left text-center"
                          >
                            <div
                              class="text-secondary"
                              style="font-size: 0.8rem"
                            >
                              <div>
                                <i class="fas fa-info-circle mr-2"></i>最大 3MB
                              </div>
                              <div>
                                <i class="fas fa-file-image mr-2"></i>JPG, WEBP
                              </div>
                              <div>
                                <i class="fas fa-expand mr-2"></i>建議 500x500px
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div
                              class="d-flex justify-content-center align-items-center"
                            >
                              <label
                                class="btn btn-sm btn-outline-primary mb-0 mr-2 cursor-pointer px-3"
                              >
                                <i class="fas fa-upload"></i> 選擇圖片
                                <input
                                  type="file"
                                  accept=".jpg,.jpeg,.webp,.png"
                                  class="d-none"
                                  @change="uploadImgPC($event, 'logo')"
                                />
                              </label>
                              <button
                                v-if="logoSrc !== noImageSrc"
                                class="btn btn-sm btn-link text-secondary p-0"
                                title="重設"
                                @click.prevent="resetLogo"
                              >
                                <i class="fas fa-trash-alt"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-md-6 mb-4"
                    v-if="getRule('ProductName').Field"
                  >
                    <p class="formTitle">
                      {{ getRule("ProductName").FieldName }}
                      <span
                        v-if="getRule('ProductName').IsFieldRequired"
                        class="red"
                        >*</span
                      >
                    </p>
                    <div>
                      <input
                        type="text"
                        name="ProName"
                        class="maxText textStyle"
                        maxlength="50"
                        :required="getRule('ProductName').IsFieldRequired"
                        :placeholder="getRule('ProductName').FieldDesc"
                        v-model="ProductName"
                      />
                    </div>
                  </div>

                  <div class="col-md-6 mb-4" v-if="getRule('CatID').Field">
                    <p class="formTitle">
                      {{ getRule("CatID").FieldName }}
                      <span v-if="getRule('CatID').IsFieldRequired" class="red"
                        >*</span
                      >
                    </p>
                    <select
                      class="form-control text-dark"
                      v-model="CatID"
                      :required="getRule('CatID').IsFieldRequired"
                      style="height: 45px"
                    >
                      <option value="">-- 請選擇 --</option>
                      <option
                        v-for="item in EventsCategories"
                        :value="item.CatID"
                        :key="item.CatID"
                      >
                        {{ item.CatName }}
                      </option>
                    </select>
                  </div>

                  <div
                    class="col-md-6 mb-4"
                    v-if="getRule('ProductDesc').Field"
                  >
                    <p class="formTitle">
                      {{ getRule("ProductDesc").FieldName }}
                      <span
                        v-if="getRule('ProductDesc').IsFieldRequired"
                        class="red"
                        >*</span
                      >
                    </p>
                    <textarea
                      name="ProDesc"
                      rows="2"
                      class="maxText textStyle"
                      maxlength="500"
                      :required="getRule('ProductDesc').IsFieldRequired"
                      :placeholder="getRule('ProductDesc').FieldDesc"
                      v-model="ProductDesc"
                    ></textarea>
                  </div>

                  <div
                    class="col-md-6 mb-4"
                    v-if="getRule('ProductSpec').Field"
                  >
                    <p class="formTitle">
                      {{ getRule("ProductSpec").FieldName }}
                      <span
                        v-if="getRule('ProductSpec').IsFieldRequired"
                        class="red"
                        >*</span
                      >
                    </p>
                    <div>
                      <input
                        type="text"
                        name="ProSpec"
                        class="maxText textStyle"
                        maxlength="50"
                        :required="getRule('ProductSpec').IsFieldRequired"
                        :placeholder="getRule('ProductSpec').FieldDesc"
                        v-model="ProductSpec"
                      />
                    </div>
                  </div>

                  <div
                    class="col-md-6 mb-4"
                    v-if="getRule('ProvidedCount').Field"
                  >
                    <p class="formTitle">
                      {{ getRule("ProvidedCount").FieldName }}
                      <span
                        v-if="getRule('ProvidedCount').IsFieldRequired"
                        class="red"
                        >*</span
                      >
                    </p>
                    <input
                      type="text"
                      name="ProvidedCount"
                      class="maxText textStyle"
                      :required="getRule('ProvidedCount').IsFieldRequired"
                      :placeholder="getRule('ProvidedCount').FieldDesc"
                      v-model="ProvidedCount"
                    />
                  </div>

                  <div class="col-md-6 mb-4" v-if="getRule('Price').Field">
                    <p class="formTitle">
                      {{ getRule("Price").FieldName }}
                      <span v-if="getRule('Price').IsFieldRequired" class="red"
                        >*</span
                      >
                    </p>
                    <input
                      type="text"
                      name="ProPrice"
                      maxlength="50"
                      class="maxText textStyle"
                      :required="getRule('Price').IsFieldRequired"
                      :placeholder="getRule('Price').FieldDesc"
                      v-model="Price"
                    />
                  </div>

                  <div
                    class="col-md-6 mb-4"
                    v-if="getRule('ContactName').Field"
                  >
                    <p class="formTitle">
                      {{ getRule("ContactName").FieldName }}
                      <span
                        v-if="getRule('ContactName').IsFieldRequired"
                        class="red"
                        >*</span
                      >
                    </p>
                    <input
                      type="text"
                      name="ContactName"
                      class="maxText textStyle"
                      maxlength="50"
                      :required="getRule('ContactName').IsFieldRequired"
                      :placeholder="getRule('ContactName').FieldDesc"
                      v-model="ContactName"
                    />
                  </div>

                  <div
                    class="col-md-6 mb-4"
                    v-if="getRule('ContactMobile').Field"
                  >
                    <p class="formTitle">
                      {{ getRule("ContactMobile").FieldName }}
                      <span
                        v-if="getRule('ContactMobile').IsFieldRequired"
                        class="red"
                        >*</span
                      >
                    </p>
                    <input
                      type="text"
                      name="ContactMobile"
                      class="maxText textStyle"
                      maxlength="50"
                      :required="getRule('ContactMobile').IsFieldRequired"
                      :placeholder="getRule('ContactMobile').FieldDesc"
                      v-model="ContactMobile"
                    />
                  </div>

                  <div class="col-md-6 mb-4" v-if="getRule('ProductUrl').Field">
                    <p class="formTitle">
                      {{ getRule("ProductUrl").FieldName }}
                      <span
                        v-if="getRule('ProductUrl').IsFieldRequired"
                        class="red"
                        >*</span
                      >
                    </p>
                    <input
                      type="text"
                      name="ProUrl"
                      maxlength="500"
                      class="maxText textStyle"
                      :required="getRule('ProductUrl').IsFieldRequired"
                      :placeholder="getRule('ProductUrl').FieldDesc"
                      v-model="ProductUrl"
                    />
                  </div>

                  <div
                    class="col-12 mb-2"
                    v-if="getRule('PromoPostText').Field"
                  >
                    <p class="formTitle">
                      {{ getRule("PromoPostText").FieldName }}
                      <span
                        v-if="getRule('PromoPostText').IsFieldRequired"
                        class="red"
                        >*</span
                      >
                    </p>
                    <textarea
                      name="PromoPostText"
                      rows="6"
                      maxlength="500"
                      class="maxText textStyle"
                      :placeholder="getRule('PromoPostText').FieldDesc"
                      v-model="PromoPostText"
                      :required="getRule('PromoPostText').IsFieldRequired"
                    ></textarea>
                  </div>

                  <div
                    class="col-md-6 mb-4"
                    v-if="getRule('CustomField1').Field"
                  >
                    <p class="formTitle">
                      {{ getRule("CustomField1").FieldName }}
                      <span
                        v-if="getRule('CustomField1').IsFieldRequired"
                        class="red"
                        >*</span
                      >
                    </p>
                    <input
                      type="text"
                      name="CustomField1"
                      maxlength="50"
                      class="maxText textStyle"
                      :required="getRule('CustomField1').IsFieldRequired"
                      :placeholder="getRule('CustomField1').FieldDesc"
                      v-model="CustomField1"
                    />
                  </div>

                  <div
                    class="col-md-6 mb-4"
                    v-if="getRule('CustomField2').Field"
                  >
                    <p class="formTitle">
                      {{ getRule("CustomField2").FieldName }}
                      <span
                        v-if="getRule('CustomField2').IsFieldRequired"
                        class="red"
                        >*</span
                      >
                    </p>
                    <input
                      type="text"
                      name="CustomField2"
                      maxlength="50"
                      class="maxText textStyle"
                      :required="getRule('CustomField2').IsFieldRequired"
                      :placeholder="getRule('CustomField2').FieldDesc"
                      v-model="CustomField2"
                    />
                  </div>

                  <div
                    class="col-md-6 mb-4"
                    v-if="getRule('CustomField3').Field"
                  >
                    <p class="formTitle">
                      {{ getRule("CustomField3").FieldName }}
                      <span
                        v-if="getRule('CustomField3').IsFieldRequired"
                        class="red"
                        >*</span
                      >
                    </p>
                    <input
                      type="text"
                      name="CustomField3"
                      maxlength="50"
                      class="maxText textStyle"
                      :required="getRule('CustomField3').IsFieldRequired"
                      :placeholder="getRule('CustomField3').FieldDesc"
                      v-model="CustomField3"
                    />
                  </div>

                  <div
                    class="col-12 mb-4"
                    v-if="
                      getRule('Facebook').Field ||
                      getRule('Instagram').Field ||
                      getRule('Custom').Field
                    "
                  >
                    <p class="formTitle mb-3">
                      <span class="topicColor"
                        >贊助方社群連結 (請至少填寫一項社群連結)</span
                      >
                      <span
                        v-if="
                          getRule('Facebook').IsFieldRequired ||
                          getRule('Instagram').IsFieldRequired
                        "
                        class="red"
                        >*</span
                      >
                    </p>

                    <div class="row">
                      <div
                        class="col-md-6 mb-3"
                        v-if="getRule('Facebook').Field"
                      >
                        <p class="formTitle mb-2">Facebook網址</p>
                        <input
                          type="text"
                          name="FbUrl"
                          maxlength="500"
                          class="maxText textStyle"
                          :placeholder="getRule('Facebook').FieldDesc"
                          v-model="Facebook"
                        />
                      </div>

                      <div
                        class="col-md-6 mb-3"
                        v-if="getRule('Instagram').Field"
                      >
                        <p class="formTitle mb-2">Instagram網址</p>
                        <input
                          type="text"
                          name="IgUrl"
                          maxlength="500"
                          class="maxText textStyle"
                          :placeholder="getRule('Instagram').FieldDesc"
                          v-model="Instagram"
                        />
                      </div>

                      <div class="col-md-6 mb-3" v-if="getRule('Custom').Field">
                        <p class="formTitle mb-2">其他社群網址</p>
                        <input
                          type="text"
                          name="OtherSocialUrl"
                          maxlength="500"
                          class="maxText textStyle"
                          :placeholder="getRule('Custom').FieldDesc"
                          v-model="Custom"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="my-3">&nbsp;</p>

              <!-- <div v-if="inputDescHidden == 0">
                <p class="formTitle mt-2">
                  {{ inputDescName }}
                  <span class="red" v-if="inputDescRequired == 0">*</span>
                </p>
                <div v-if="LocalExh">
                  <div    >
                    <input
                      type="text"
                      name="Desc"
                      class="maxText textStyle"
                      :required="inputDescRequired == 0"
                      maxlength="20"
                      v-model="reg_Desc"
                    />
                    <span>中 </span>
                  </div>
                  <div class="blueBG mt-1" v-if="inputDescNotes">
                    {{ inputDescNotes }}
                  </div>
                </div>
                <div v-if="einputDescName">
                  <div class="langTip mt-2">
                    <input
                      type="text"
                      name="Desc"
                      class="maxText textStyle"
                      :required="inputDescRequired == 0"
                      maxlength="50"
                      v-model="ereg_Desc"
                    />
                    <span>英 </span>
                  </div>
                  <div class="blueBG mt-1" v-if="einputDescNotes">
                    {{ einputDescNotes }}
                  </div>
                </div>

                <p class="my-3">&nbsp;</p>
              </div>

              <div class="mt-3" v-if="inputDescHidden2 == 0">
                <p class="formTitle">
                  {{ inputDescName2 }}
                  <span class="red" v-if="inputDescRequired2 == 0">*</span>
                </p>
                <div v-if="LocalExh">
                  <div    >
                    <input
                      type="text"
                      name="Desc2"
                      class="maxText textStyle"
                      :required="inputDescRequired2 == 0"
                      maxlength="20"
                      v-model="reg_Desc2"
                    />
                    <span>中 </span>
                  </div>
                  <div class="blueBG mt-1" v-if="inputDescNotes2">
                    {{ inputDescNotes2 }}
                  </div>
                </div>
                <div v-if="einputDescName">
                  <div class="langTip mt-2">
                    <input
                      type="text"
                      name="Desc2"
                      class="maxText textStyle"
                      :required="inputDescRequired2 == 0"
                      maxlength="50"
                      v-model="ereg_Desc2"
                    />
                    <span>英 </span>
                  </div>
                  <div class="blueBG mt-1" v-if="einputDescNotes2">
                    {{ einputDescNotes2 }}
                  </div>
                </div>

                <p class="my-3">&nbsp;</p>
              </div>

              <span v-if="inputOnlineDateHidden == 0">
                <p class="formTitle mt-3">
                  上市時間
                  <span class="red" v-if="inputOnlineDateRequired == 0">*</span>
                </p>
                <div>
                  <input
                    type="text"
                    name="LaunchDate"
                    class="maxText textStyle"
                    :required="inputOnlineDateRequired == 0"
                    maxlength="20"
                    v-model="reg_LaunchDate"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputPriceHidden == 0">
                <p class="formTitle">
                  市價(NT$)
                  <span class="red" v-if="inputPriceRequired == 0">*</span>
                </p>
                <div>
                  <input
                    type="text"
                    name="Price"
                    class="maxText textStyle"
                    :required="inputPriceRequired == 0"
                    maxlength="20"
                    v-model="reg_Price"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputDiscountPriceHidden == 0">
                <p class="formTitle">
                  展場限定價(NT$)
                  <span class="red" v-if="inputDiscountPriceRequired == 0"
                    >*</span
                  >
                </p>
                <div>
                  <input
                    type="text"
                    name="Discount"
                    class="maxText textStyle"
                    :required="inputDiscountPriceRequired == 0"
                    maxlength="20"
                    v-model="reg_DiscountPrice"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span> -->
              <div class="d-flex justify-content-center">
                <input type="submit" value="確定送出" class="btnStyle mr-4" />
                <div class="btnStyle btnGray" @click.prevent="toCampaignDetail">
                  返回
                </div>
              </div>
            </form>
          </div>
        </div>
      </article>
    </div>

    <!-- 桌機板裁切工具 Modal  -->
    <div id="cropImagePop" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header d-flex justify-content-between">
            <div class="modal-title" style="font-size: 25px">
              <div class="d-flex align-self-center">
                <div class="mr-3">
                  <img src="../../../assets/images/cropImg.png" width="30px" />
                </div>
                <div style="font-size: 25px">編輯產品圖片</div>
              </div>
            </div>
            <div
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-8">
                <div class="CropBoxStyle">
                  <vue-cropper
                    ref="cropper"
                    :img="option.img"
                    :output-size="option.size"
                    :output-type="option.outputType"
                    :info="true"
                    :full="option.full"
                    :fixed="fixed"
                    :can-move="option.canMove"
                    :can-move-box="option.canMoveBox"
                    :fixed-box="option.fixedBox"
                    :original="option.original"
                    :auto-crop="option.autoCrop"
                    :auto-crop-width="option.autoCropWidth"
                    :auto-crop-height="option.autoCropHeight"
                    :center-box="option.centerBox"
                    :high="option.high"
                    :max-img-size="option.max"
                    :fixed-number="fixedNumber"
                    :enlarge="option.enlarge"
                    :infoTrue="option.infoTrue"
                    :mode="option.mode"
                    @real-time="realTime"
                  >
                  </vue-cropper>
                </div>

                <div class="d-flex justify-content-between mt-3 mx-3">
                  <div>
                    <button @click="rotateLeft" class="btn btn-info">
                      向左旋轉
                    </button>
                    <button @click="rotateRight" class="btn btn-info ml-2">
                      向右旋轉
                    </button>
                    <button @click="changeScale(1)" class="btn btn-info ml-2">
                      放大
                    </button>
                    <button @click="changeScale(-1)" class="btn btn-info ml-2">
                      縮小
                    </button>
                  </div>
                  <div>
                    <button
                      @click="refreshCrop"
                      class="btn btn-outline-info ml-5"
                    >
                      重設
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div :style="previewStyle1" class="ImgPreCrop">
                  <div :style="previews.div">
                    <img :src="previews.url" :style="previews.img" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr />
          <div class="modal-footer">
            <div>
              <button
                type="button"
                id="cropImageBtn"
                class="btn btn-primary btn-lg mr-2"
                @click="OutputPC()"
              >
                裁切
              </button>
              <button
                type="button"
                class="btn btn-lg btn-secondary"
                data-dismiss="modal"
              >
                關閉
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 行動版裁切工具 Modal  -->
    <div
      class="modal fade"
      id="cropperMb"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p>&middot; 系統將自動調整圖片至正方形尺寸。</p>
            <p>&middot; 如有裁切及編輯圖片之需求，請至 PC 裝置上傳圖片。</p>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              id="cropperMb"
              class="btn btn-sm btn-primary"
              @click="OutputMb()"
            >
              確定
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "編輯贈品贊助活動 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      FieldRules: [],
      LocalExh: true,
      UserId: "",
      RegNo: "",
      lang: "tw",
      EventDetail: {},
      MarketingRegisterList: [],
      reg_Desc: "",
      reg_Desc2: "",
      ereg_Desc: "",
      ereg_Desc2: "",
      reg_LaunchDate: "",
      reg_Price: "",
      reg_DiscountPrice: "",
      EventCatList: [],
      eventId: "",
      inputDescHidden: "",
      inputOnlineDateHidden: "",
      inputPriceHidden: "",
      inputDiscountPriceHidden: "",
      inputDescName: "",
      EventName: "",

      einputDescName: "",
      einputDescName2: "",
      einputDescNotes: "",
      einputDescNotes2: "",

      inputDescRequired: "",
      inputDescNotes: "",
      inputDescName2: "",
      inputDescHidden2: "",
      inputDescRequired2: "",
      inputDescNotes2: "",
      inputOnlineDateRequired: "",
      inputPriceRequired: "",
      inputDiscountPriceRequired: "",
      EventsCategories: [],
      ProName: "",
      ProDesc: "",
      ProSpec: "",
      ProPrice: "",
      ContactName: "",
      ContactMobile: "",
      ProUrl: "",
      PromoPostText: "",
      eventType: "",
      OtherSocialUrl: "",
      FbUrl: "",
      IgUrl: "",
      modelSrc: "../../../assets/images/default.jpg",
      noImageSrc: "../../../assets/images/default.jpg",
      modelEnSrc: "../../../assets/images/default.jpg",
      noImageEnSrc: "../../../assets/images/default.jpg",
      hasImgfile: false,

      previews: {},
      previewStyle1: {},
      lang: "tw",

      option: {
        img: "", // 裁剪图片的地址V
        max: 9999, //限制图片最大宽度和高度
        enlarge: 1, //图片根据截图框输出比例倍数
        mode: "contain",

        centerBox: false, // 截图框是否被限制在图片里面
        canMove: true, //上传图片是否可以移动
        infoTrue: true,

        fixedBox: true, // 固定截图框大小 不允许改变
        canMoveBox: false, // 截图框能否拖动
        autoCrop: true, // 是否默认生成截图框
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 500, // 默认生成截图框宽度
        autoCropHeight: 500,

        full: true, //是否输出原图比例的截图，X匯出等比例(長型就匯長型)
        high: true, //是否按照设备的dpr 输出等比例图片，X匯出等比例(長型就匯長型)
        original: true, // 上传图片按照原始比例渲染

        size: 1, //裁剪生成图片的质量V
        outputType: "webp", // 裁剪生成图片的格式V
      },

      fixed: true, // 是否开启截图框宽高固定比例
      fixedNumber: [1, 1], // 截图框的宽高比例

      hasImgfile: false,

      logoSrc: "../../../assets/images/default.jpg",
      hasLogofile: false,
      currentUploadType: "product",
      regId: "",

      ProductImage: "",
      ProductName: "", // 對應原先的 ProName
      CatID: "",
      ProductDesc: "", // 對應原先的 ProDesc
      ProductSpec: "", // 對應原先的 ProSpec
      ProvidedCount: "",
      Price: "", // 對應原先的 ProPrice
      LOGO: "",
      ContactName: "",
      ContactMobile: "",
      ProductUrl: "", // 對應原先的 ProUrl
      Facebook: "", // 對應原先的 FbUrl
      Instagram: "", // 對應原先的 IgUrl
      Custom: "", // 對應原先的 OtherSocialUrl
      PromoPostText: "",
      CustomField1: "",
      CustomField2: "",
      CustomField3: "",
    };
  },

  watch: {},

  methods: {
    toCampaignList() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/campaign?no=${vm.RegNo}`;
    },

    toCampaignDetail() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/campaignDetail?no=${vm.RegNo}&eventId=${vm.eventId}&eventType=${vm.eventType}`;
    },
    getRule(fieldKey) {
      if (!this.FieldRules || this.FieldRules.length === 0) return {};
      return this.FieldRules.find((item) => item.Field === fieldKey) || {};
    },
    toEventMain() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
    },
    AddCampaignPro() {
      const vm = this;
      const url = "/ApiMarketingCampaign/Gift/Registrations/";
      const defaultPath = "../../../assets/images/default.jpg";

      // 1. 處理圖片路徑（若為預設圖則視為空字串，方便後續驗證與上傳）
      const currentProductImg =
        this.modelSrc === defaultPath ? "" : this.modelSrc;
      const currentLogoImg = this.logoSrc === defaultPath ? "" : this.logoSrc;

      // 2. 自動判定圖片必填規則
      const imageCheckList = [
        { key: "ProductImage", value: currentProductImg },
        { key: "LOGO", value: currentLogoImg },
      ];

      for (const item of imageCheckList) {
        const rule = this.getRule(item.key);
        // 判斷：API 有該欄位 (Field) 且 設定為必填 (IsFieldRequired)
        if (rule && rule.Field && rule.IsFieldRequired) {
          if (!item.value || item.value === "") {
            alert(`請上傳【${rule.FieldName}】`);
            return; // 中斷執行，不發送 API
          }
        }
      }

      const fbRule = this.getRule("Facebook");
      const igRule = this.getRule("Instagram");
      const customRule = this.getRule("Custom");

      // 只要其中一個被後台設定為必填，就啟動「三選一」檢查
      const isSocialRequired =
        (fbRule && fbRule.IsFieldRequired) ||
        (igRule && igRule.IsFieldRequired) ||
        (customRule && customRule.IsFieldRequired);

      if (isSocialRequired) {
        // 檢查使用者這三個欄位到底有沒有寫東西
        const hasAnySocial =
          (this.FbUrl && this.FbUrl.trim() !== "") ||
          (this.IgUrl && this.IgUrl.trim() !== "") ||
          (this.OtherSocialUrl && this.OtherSocialUrl.trim() !== "");

        if (!hasAnySocial) {
          alert("「贊助方社群連結」請至少填寫一項欄位。");
          return; // 中斷執行
        }
      }

      // 3. 組裝 API 所需資料
      const info = {
        RegID: this.regId, // 產品報名編號
        EventID: this.eventId, // 活動編號
        Serno: this.RegNo, // 報名表序號

        // 產品核心資訊
        ProductImage: currentProductImg,
        ProductName: this.ProductName, // 產品名稱
        ProductDesc: this.ProductDesc, // 產品說明
        ProductSpec: this.ProductSpec, // 產品規格
        ProvidedCount: this.ProvidedCount, // 提供數量
        Price: this.Price, // 價格

        // 廠商與聯絡資訊
        LOGO: currentLogoImg,
        ContactName: this.ContactName, // 聯絡人姓名
        ContactMobile: this.ContactMobile, // 聯絡人行動電話
        ProductUrl: this.ProUrl, // 產品網址

        // 類別與社群連結
        CatID: this.CatID, // 類別編號
        Facebook: this.Facebook, // Facebook 連結
        Instagram: this.Instagram, // Instagram 連結
        Custom: this.Custom, // 自訂社群連結
        PromoPostText: this.PromoPostText, // 推廣文案

        // 自訂欄位
        CustomField1: this.CustomField1,
        CustomField2: this.CustomField2,
        CustomField3: this.CustomField3,
      };

      // 4. 發送 API 並處理回傳狀態
      axios
        .post(url, info)
        .then(function (response) {
          if (response.data.Code == 200) {
            alert("您已成功編輯資訊！");
            window.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/campaignDetail?no=${vm.RegNo}&eventId=${vm.eventId}&eventType=${vm.eventType}`;
          } else {
            alert(response.dataMessage || "儲存失敗，請檢查欄位內容。");
          }
        })
        .catch(function (error) {
          console.log(error);
          // --- 這裡就是處理 400 錯誤的地方 ---
          if (error.response) {
            // 伺服器有回傳，但狀態碼超出 2xx 範圍 (例如 400, 403, 500)
            console.log("Status:", error.response.status); // 這裡會看到 400
            console.log("Data:", error.response.data); // 這裡會看到後端回傳的物件內容

            // 取得後端回傳的 Message
            const errorMessage =
              error.response.data.Message || "發生 400 錯誤，請檢查資料格式。";
            alert(errorMessage);
          } else if (error.request) {
            // 請求已發出，但沒收到回應 (網路斷線、伺服器掛了)
            alert("伺服器無回應，請稍後再試。");
          } else {
            // 其他設定問題
            alert("發送請求時出錯：" + error.message);
          }
        });
    },

    backSelectPro() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}`;
    },

    OpenCategoryModal() {
      $("#SearchModal").modal("show");
    },
    uploadImgPC(e, type = "product") {
      // 增加 type 參數
      const vm = this;
      vm.currentUploadType = type; // 紀錄現在是誰在動

      var file = e.target.files[0];
      if (!/\.(jpg|jpeg|JPG|JPEG|webp|WEBP)$/.test(e.target.value)) {
        alert("上傳檔案類型必須是 JPG 或 WebP！");
        return false;
      }

      var reader = new FileReader();
      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;
        if (isLt5M) {
          $("#cropImagePop").modal("show");
          $("#cropImagePop").on("shown.bs.modal", function () {
            vm.option.img = window.URL.createObjectURL(
              new Blob([e.target.result]),
            );
          });
        } else {
          alert("上傳圖片大小請勿超過 3MB！");
        }
      };
      reader.readAsArrayBuffer(file);
      e.target.value = "";
    },

    uploadImgMb(e, type = "product") {
      // 補上 type
      const vm = this;
      vm.currentUploadType = type; // 紀錄現在是誰在動

      var file = e.target.files[0];
      // ...中間檢查碼不變...

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;
        if (isLt5M) {
          this.option.img = window.URL.createObjectURL(
            new Blob([e.target.result]),
          );
          vm.showImg = true;
          $("#cropperMb").modal("show");
        } else {
          alert("Maximum file size : 3MB");
        }
      };
      // ...
    },

    OutputPC() {
      const vm = this;
      this.$refs.cropper.getCropData((data) => {
        // 根據標記判斷要更新哪個欄位
        if (vm.currentUploadType === "product") {
          vm.modelSrc = data;
          vm.hasImgfile = true;
        } else if (vm.currentUploadType === "logo") {
          vm.logoSrc = data;
          vm.hasLogofile = true;
        }

        $("#cropImagePop").on("hidden.bs.modal", function (e) {
          vm.option.img = "/";
          // 清除事件監聽，避免重複觸發
          $(this).off("hidden.bs.modal");
        });

        $("#cropImagePop").modal("hide");
      });
    },

    OutputEnPC() {
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelEnSrc = data;
        $("#cropImagePop").on("hidden.bs.modal", function (e) {
          vm.hasImgfile = true;
          vm.option.img = "/";
        });
        $("#cropImagePop").modal("hide");

        window.setTimeout(
          () =>
            alert(
              'The picture uploaded successfully. Please also fill out the product information required, and click "Submit" to complete the process.',
            ),
          1000,
        );
      });
    },

    OutputMb() {
      const vm = this;
      this.$refs.cropper.getCropData((data) => {
        // 根據標記判斷存到哪裡
        if (vm.currentUploadType === "product") {
          vm.modelSrc = data;
          vm.hasImgfile = true;
        } else if (vm.currentUploadType === "logo") {
          vm.logoSrc = data;
          vm.hasLogofile = true;
        }
      });
      $("#cropperMb").modal("hide");
      vm.showImg = false;
    },

    OutputEnMb() {
      // 输出
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelEnSrc = data;
      });

      $("#cropperMb").modal("hide");
      vm.showImg = false;
    },
    resetImg() {
      const vm = this;
      vm.modelSrc = "../../../assets/images/default.jpg";
      vm.hasImgfile = false;
    },
    // 实时预览函数
    realTime(data) {
      var previews = data;
      var h = 0.5;
      var w = 0.2;

      this.previewStyle1 = {
        width: previews.w + "px",
        height: previews.h + "px",
        overflow: "hidden",
        margin: "0",
        zoom: h,
      };

      this.previews = data;
    },

    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },

    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },

    refreshCrop() {
      this.$refs.cropper.refresh();
    },

    resetLogo() {
      this.logoSrc = this.noImageSrc;
      this.hasLogofile = false;
    },
  },

  computed: {},

  created() {
    const vm = this;

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    const urlParams = new URLSearchParams(window.location.search);

    vm.RegNo = urlParams.get("no");
    vm.eventId = urlParams.get("eventID") || urlParams.get("eventId");
    vm.eventType = urlParams.get("eventType");
    vm.regId = urlParams.get("regId");

    //取得總資料
    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/MarketingEvents/Detail/${vm.eventId}?type=${vm.eventType}&lang=tw`,
      )
      .then((response) => {
        vm.EventDetail = response.data.Data;

        let openTime = new Date(vm.EventDetail.RegStartTime).getTime();
        let closeTime = new Date(vm.EventDetail.RegEndTime).getTime();
        const nowTime = Date.now();
        if (nowTime < openTime) {
          alert("活動尚未開放");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/campaign?no=${vm.RegNo}`;
        } else if (nowTime > closeTime) {
          alert("活動已截止");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/campaign?no=${vm.RegNo}`;
        }
      });

    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/MarketingEvents/Categories/${vm.eventId}?type=${vm.eventType}&lang=tw`,
      )
      .then((response) => {
        vm.EventsCategories = response.data.Data;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/Gift/Registration/${vm.eventId}?RegId=${vm.regId}&type=${vm.eventType}&lang=tw`,
      )
      .then((response) => {
        console.log("Get API Response:", response);
        const apiData = response.data.Data;
        vm.FieldRules = apiData;

        // 自動將 API 的 FieldValue 映射到 data 變數中
        apiData.forEach((item) => {
          // 1. 處理產品圖片的特殊映射與顯示狀態
          if (item.Field === "ProductImage" && item.FieldValue) {
            vm.modelSrc = item.FieldValue;
            vm.hasImgfile = true; // 開啟產品圖顯示切換
          }

          // 2. 處理 LOGO 的特殊映射與顯示狀態
          if (item.Field === "LOGO" && item.FieldValue) {
            vm.logoSrc = item.FieldValue;
            vm.hasLogofile = true; // 開啟 LOGO 顯示切換
          }

          // 3. 原有的通用映射（處理其他如 ProductName, ProductDesc 等欄位）
          // 只要 item.Field 的名稱跟你在 data 定義的變數名一樣，就會自動填入
          if (Object.prototype.hasOwnProperty.call(vm, item.Field)) {
            vm[item.Field] = item.FieldValue;
          }
        });
      })
      .catch((error) => {
        console.error("讀取資料失敗:", error);
      });
  },
};
</script>

<style lang="scss">
.modal-xl {
  max-width: 940px;
}

.proRight {
  border-left: 0px solid #dadce0;
}

.proLeft {
  padding-right: 0px;
}

.modal-body {
  height: 75vh;
  overflow-y: auto;
}

.el-collapse-item__header {
  font-size: 17px;
  font-weight: 550;

  height: 55px;
  line-height: 23px;
}
</style>
